<app-dialog (cancel)="cancel.emit()" [minWidthDefault]="false" [show]="show" [showHeader]="false">
  <div class="reset-pin-dialog-container">
    <div *ngIf="currentStep === ResetPinStepsEnum.Auth" class="header auth">
      Reset Your PIN
    </div>
    <div *ngIf="currentStep === ResetPinStepsEnum.PIN" class="header pin">
      Create a new 4-digit PIN
    </div>
    <div *ngIf="currentStep === ResetPinStepsEnum.Done" class="header done">
      <img src="assets/icons/icon-alert-success-blue.svg" alt="success-icon" />
      PIN reset
    </div>

    <div *ngIf="currentStep === ResetPinStepsEnum.Auth" class="subheader auth">
      Before we can reset your PIN you'll need to confirm your account.
    </div>
    <div *ngIf="currentStep === ResetPinStepsEnum.PIN" class="subheader pin">
      You can change your PIN later in My Profile.
    </div>
    <div *ngIf="currentStep === ResetPinStepsEnum.Done" class="subheader done">
      You are being redirected.
    </div>

    <form novalidate
          *ngIf="currentStep === ResetPinStepsEnum.Auth"
          [formGroup]="checkUserForm"
          class="form-container"
    >
      <app-input [type]="'email'"
                 [autofocus]="show"
                 [label]="'Email'"
                 formControlName="email"
                 (keyupEnter)="focusInput('passwordInput')"
      ></app-input>
      <div class="password-input">
        <app-input [type]="'password'"
                   [label]="'Password'"
                   formControlName="password"
                   #passwordInput
                   (keyupEnter)="checkUser()"
        ></app-input>
      </div>

      <div class="error-message" *ngIf="checkErrorMessage">{{checkErrorMessage}}</div>
    </form>

    <div *ngIf="currentStep === ResetPinStepsEnum.PIN" class="pin-input-container">
      <img (click)="togglePIN()" [hidden]="hidePIN" class="password-icon"
           src="assets/icons/icon-field-hide-password.svg" alt="password-icon"/>
      <img (click)="togglePIN()" [hidden]="!hidePIN" class="password-icon shown"
           src="assets/icons/icon-field-show-password.svg" alt="password-icon"/>
      <app-pin-input [validateSequence]="true"
                     [isLarge]="true"
                     [inputsType]="inputsType"
                     [focused]="currentStep === ResetPinStepsEnum.PIN"
                     [disabled]="loadingProfile$ | async"
                     (pinValueComplete)="pinEntered($event)"
                     #pinInput
      ></app-pin-input>
      <div *ngIf="pinErrorMessage" class="error-message">{{pinErrorMessage}}</div>
    </div>

    <div *ngIf="currentStep !== ResetPinStepsEnum.Done" class="controls">
      <app-button *ngIf="currentStep === ResetPinStepsEnum.Auth"
                  customClasses="w-full"
                  class="submit-btn"
                  (clicked)="checkUser()"
                  [disabled]="(loadingAuth$ | async) || checkUserForm.invalid"
                  [text]="'Continue'"
                  [loading]="loadingAuth$ | async"
      ></app-button>

      <app-button *ngIf="currentStep === ResetPinStepsEnum.PIN"
                  customClasses="w-full"
                  class="submit-btn"
                  (clicked)="setPIN()"
                  [disabled]="(loadingProfile$ | async) || !pinValue"
                  [text]="'Set PIN'"
                  [loading]="loadingProfile$ | async"
                  #setPinButton
      ></app-button>
    </div>
  </div>
</app-dialog>
